/**
 * 列表页 session 缓存：刷新/返回时先展示旧数据，后台拉取后再更新，减少白屏与 loading 闪烁。
 */

const memory = new Map()
const PREFIX = 'cp:list:'
const EXAM_LIST_BUST_KEY = 'cp:exam:list:bust'

export function listCacheKey(name, variant = 'default') {
  return `${PREFIX}${name}:${variant}`
}

export function readListCache(key, opts = {}) {
  const { maxAgeMs, bust } = opts
  let parsed = memory.get(key)
  if (!parsed) {
    try {
      const raw = sessionStorage.getItem(key)
      if (!raw) return null
      parsed = JSON.parse(raw)
      memory.set(key, parsed)
    } catch {
      return null
    }
  }
  if (bust != null && parsed.bust != null && String(parsed.bust) !== String(bust)) {
    clearListCache(key)
    return null
  }
  if (maxAgeMs && parsed.cachedAt && Date.now() - parsed.cachedAt > maxAgeMs) {
    clearListCache(key)
    return null
  }
  return parsed
}

export function writeListCache(key, data, extra = {}) {
  const payload = { ...data, cachedAt: Date.now(), ...extra }
  memory.set(key, payload)
  try {
    sessionStorage.setItem(key, JSON.stringify(payload))
  } catch {
    // sessionStorage 满时仅保留内存
  }
}

export function clearListCache(key) {
  memory.delete(key)
  try {
    sessionStorage.removeItem(key)
  } catch {
    // ignore
  }
}

export function currentExamListBust() {
  try {
    return localStorage.getItem(EXAM_LIST_BUST_KEY) || '0'
  } catch {
    return '0'
  }
}

/** 上下架 / 删除恢复 / 审核后调用：丢掉 /exames 的 session 快照 */
export function bumpExamListCache() {
  const t = String(Date.now())
  try {
    localStorage.setItem(EXAM_LIST_BUST_KEY, t)
  } catch {
    // ignore
  }
  const toRemove = []
  for (const key of memory.keys()) {
    if (key.startsWith(`${PREFIX}exam:`)) {
      toRemove.push(key)
    }
  }
  try {
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i)
      if (k && k.startsWith(`${PREFIX}exam:`)) {
        toRemove.push(k)
      }
    }
  } catch {
    // ignore
  }
  Array.from(new Set(toRemove)).forEach(clearListCache)
}

/** 测评 / 课程：登录态不同接口，缓存分桶 */
export function authListVariant() {
  return localStorage.getItem('jwt_token') ? 'auth' : 'guest'
}
